import { useQuery } from '@tanstack/react-query';

import {
  cardsService,
  FetchCardsRequest,
  FetchCardsResponse,
  individualsService,
} from '@aslanpay/portal-common-lib';

const useFetchCards = (
  { ids, walletIds, status, sortBy, sort, page, size }: FetchCardsRequest,
  enabled = true,
  shouldRefetch = false
) => {
  return useQuery<FetchCardsResponse, Error>(
    ['fetchCards', ids, walletIds, status, sortBy, sort, page, size],
    async () => {
      const cards = await cardsService.fetchCards({
        ids,
        walletIds,
        status,
        sortBy,
        sort,
        page,
        size,
      });

      const statusChangedIndividuals = await individualsService.fetchIndividuals({
        ids: cards.list.map((card) => card.statusChangedBy),
        page: 0,
        size: 999999,
      });

      const cardsList = cards.list.map((card) => {
        const statusChangedByIndividual = statusChangedIndividuals.list.find(
          (individual) => individual.id === card.statusChangedBy
        );

        const isChangedBySystem = card.statusChangedBy === '00000000-0000-0000-0000-000000000000';

        let statusChangedByName = '';
        let statusChangedByRole = '';

        if (isChangedBySystem) {
          statusChangedByName = 'System';
        } else if (!isChangedBySystem && statusChangedByIndividual) {
          statusChangedByName = `${statusChangedByIndividual.firstName} ${statusChangedByIndividual.lastName}`;
          statusChangedByRole = statusChangedByIndividual.role;
        }

        return { ...card, statusChangedByName, statusChangedByRole };
      });

      return { ...cards, list: cardsList };
    },
    { enabled, refetchInterval: shouldRefetch ? 2000 : undefined }
  );
};

export default useFetchCards;
